(function () {
  'use strict';

  var root = document.querySelector('[data-tcb-equipment-guides]');
  if (!root) return;

  var grid = root.querySelector('.tcb-bg-guides__grid');
  var cards = grid ? grid.querySelectorAll('[data-eg-guide]') : [];
  var filterBtns = root.querySelectorAll('[data-eg-filter]');
  var emptyEl = root.querySelector('[data-eg-empty]');
  var countEl = root.querySelector('[data-eg-count]');
  var searchInput = root.querySelector('[data-eg-search]');
  var searchForm = root.querySelector('[data-eg-search-form]');
  var typeSelect = root.querySelector('[data-eg-type-filter]');
  var floorSelect = root.querySelector('[data-eg-floor-filter]');
  var sortSelect = root.querySelector('[data-eg-sort]');
  var typeCountEls = root.querySelectorAll('[data-eg-type-count]');

  var activeFilter = 'all';
  var searchQuery = '';
  var floorFilter = 'all';
  var sortMode = 'popular';

  function norm(value) {
    return (value || '').toLowerCase().trim();
  }

  function cardCategories(card) {
    return norm(card.getAttribute('data-categories')).split(/\s+/).filter(Boolean);
  }

  function updateTypeCounts() {
    var counts = {};
    cards.forEach(function (card) {
      cardCategories(card).forEach(function (cat) {
        counts[cat] = (counts[cat] || 0) + 1;
      });
    });
    typeCountEls.forEach(function (el) {
      var key = el.getAttribute('data-eg-type-count');
      if (!key) return;
      var n = counts[key] || 0;
      el.textContent = n > 0 ? String(n) : '0';
    });
  }

  function sortCards() {
    if (!grid || cards.length < 2) return;
    var list = Array.prototype.slice.call(cards);
    list.sort(function (a, b) {
      if (sortMode === 'title') {
        return norm(a.getAttribute('data-title')).localeCompare(norm(b.getAttribute('data-title')));
      }
      var ap = Number(a.getAttribute('data-popular') || 0);
      var bp = Number(b.getAttribute('data-popular') || 0);
      if (bp !== ap) return bp - ap;
      return norm(a.getAttribute('data-title')).localeCompare(norm(b.getAttribute('data-title')));
    });
    list.forEach(function (card) {
      grid.appendChild(card);
    });
    cards = grid.querySelectorAll('[data-eg-guide]');
  }

  function applyFilters() {
    var visible = 0;
    cards.forEach(function (card) {
      var categories = cardCategories(card);
      var title = norm(card.getAttribute('data-title'));
      var excerpt = norm(card.getAttribute('data-excerpt'));
      var floor = norm(card.getAttribute('data-floor-type'));
      var typeOk = activeFilter === 'all' || categories.indexOf(activeFilter) !== -1;
      var floorOk = floorFilter === 'all' || floor === floorFilter;
      var searchOk = !searchQuery || title.indexOf(searchQuery) !== -1 || excerpt.indexOf(searchQuery) !== -1;
      var show = typeOk && floorOk && searchOk;
      card.hidden = !show;
      if (show) visible += 1;
    });
    if (emptyEl) emptyEl.hidden = visible > 0;
    if (countEl) {
      countEl.textContent = visible === 1 ? '1 guide' : visible + ' guides';
    }
  }

  function setActiveFilter(nextFilter) {
    activeFilter = nextFilter || 'all';
    filterBtns.forEach(function (btn) {
      var btnFilter = btn.getAttribute('data-eg-filter') || 'all';
      var isActive = btnFilter === activeFilter;
      btn.classList.toggle('is-active', isActive);
      if (btn.classList.contains('tcb-bg-filter-bar__pill')) {
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      }
    });
    if (typeSelect && typeSelect.value !== activeFilter) {
      typeSelect.value = activeFilter;
    }
    applyFilters();
  }

  filterBtns.forEach(function (btn) {
    btn.addEventListener('click', function (event) {
      if (btn.tagName === 'A') event.preventDefault();
      setActiveFilter(btn.getAttribute('data-eg-filter'));
      var target = root.querySelector('#tcb-eg-all-guides');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  if (typeSelect) {
    typeSelect.addEventListener('change', function () {
      setActiveFilter(typeSelect.value || 'all');
    });
  }

  if (floorSelect) {
    floorSelect.addEventListener('change', function () {
      floorFilter = floorSelect.value || 'all';
      applyFilters();
    });
  }

  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      sortMode = sortSelect.value || 'popular';
      sortCards();
      applyFilters();
    });
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      searchQuery = norm(searchInput.value);
      applyFilters();
    });
  }

  if (searchForm) {
    searchForm.addEventListener('submit', function (event) {
      event.preventDefault();
      searchQuery = norm(searchInput && searchInput.value);
      applyFilters();
      var target = root.querySelector('#tcb-eg-all-guides');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  var hashFilter = (window.location.hash || '').replace(/^#/, '');
  if (hashFilter && root.querySelector('[data-eg-filter="' + hashFilter + '"]')) {
    setActiveFilter(hashFilter);
    var allGuides = root.querySelector('#tcb-eg-all-guides');
    if (allGuides) {
      requestAnimationFrame(function () {
        allGuides.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  sortCards();
  updateTypeCounts();
  applyFilters();
})();
